import { createApp } from 'vue'
import App from './App.vue'
import { setupRouter } from './router'; // 라우터를 가져옵니다.
import i18n from './i18n'; // i18n 설정 가져오기

import './assets/styles/main.css';    // 전역 CSS 파일 불러옴
import './assets/fonts/Pretendard/variable/pretendardvariable.css';
import './assets/fonts/Poppins/stylesheet.css';

// 전역적으로 우클릭 메뉴 비활성화
window.addEventListener('contextmenu', (event) => {
    event.preventDefault();
});

// createApp(App).use(router).mount('#app')
(async () => {
  const app = createApp(App);
  const router = await setupRouter(); // 여기서 기다림
  app.use(router);
  app.use(i18n);
  app.mount('#app');
})();